import React from 'react'
import styles from './MaxReachedDialog.scss'
import { StyledModal } from 'common/StyledModal'
import { Button } from 'common/Button'
import { getCurrentUser } from 'lib/utils'
import { Msg, commonCTAs } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export const MaxReachedDialog = ({ onRequestClose }) => {
  const trial = getCurrentUser().eligibleForOnetimeTrial

  return (
    <StyledModal maxWidth={400} onRequestClose={onRequestClose} showModal>
      <div className={styles.MaxReachedDialog}>
        <h2><T id='MaxReachedDialog.doMore' defaultMessage='Do more with Premium' /></h2>
        <p>
          <T
            id='MaxReachedDialog.maxHit'
            defaultMessage="You've hit the maximum number of two published ride reports for a Starter account. You can continue to create and edit drafts, but you won't be able to publish them until you upgrade or unpublish another report." />
        </p>
        <p>
          <T
            id='MaxReachedDialog.wantToShare'
            defaultMessage='Want to share this story? You can publish an unlimited number of ride reports with our <strong>Premium</strong> account.'
            values={{ strong: (...c) => <strong>{c}</strong> }} />
        </p>
        <div className={styles.buttons}>
          <a href={`/subscriptions/new?account_level=premium${trial ? '&trial=1' : ''}`}>
            <Button className={styles.upgradeButton}>
              <Msg m={trial ? commonCTAs.startFreeTrial : commonCTAs.upgradeNow} />
            </Button>
          </a>
        </div>
      </div>
    </StyledModal>
  )
}
